
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SmComponent } from "./sm.component";
import { NavigationBarComponent } from "../shell-components/navigation-bar.component";
import { SidebarLeftComponent } from "../shell-components/sidebar-left.component";
import { SidebarRightComponent } from "../shell-components/sidebar-right.component";
import { PageContainerComponent } from "../shell-components/page-container.component";
import { FooterComponent } from "../shell-components/footer.component";
import { AppContainerComponent } from "../formcontainer/formcontainer.component";
import { ComponentModule } from "../../components/component.module";
import { SmRoutingModule } from "./sm.routing";
import { SMStudentinfoService } from "../forms/school-management/transaction/studentprofile/studentprofile.service";
import { EmployeeinfohdrService } from "../forms/Employee-Profile/Employeeinfohdr/employee-profile/employee-profile.service";
import { StudentBirthday } from "../shell-components/Student-birthday/Studbirthday.component";
import { TemplateService } from "../forms/organizational-setup/setup/template/template.service";
import { SMMessageService } from "../forms/Communication/Message/SMMessage.service";
import { StudentbirthdayService } from "../shell-components/Student-birthday/studentbirthday.service";
import { EmployeeBirthday } from "../shell-components/Employee-Birthday/Employeebirthday.component";
import { StudentguardianService } from "../forms/school-management/transaction/studentguardianlist/studentguardian/studentguardian.service";
import { favoriteService } from "../forms/sms/menuview/Favorite.service";
import { ChangepasswordModule } from "../../login/changepassword/changepassword.module";
import { Ng2FilterPipeModule } from 'ng2-filter-pipe';
import { ParentnavbarComponent } from "../Parent-Portal/parentnavbar/parentnavbar.component";
import { ParentsidebarComponent } from "../Parent-Portal/parentsidebar/parentsidebar.component";
import { parentcontainerComponent } from "../Parent-Portal/parentcontainer/parentcontainer.component";
import { ParentformconatinerComponent } from "../Parent-Portal/parentformconatiner/parentformconatiner.component";
import { GuardianRoutingModule } from "../Parent-Portal/guardian.routing";
import {  Guardiancomponent } from "../Parent-Portal/guardian.component";
 

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentModule,
    SmRoutingModule,
    GuardianRoutingModule,
    ChangepasswordModule,
    Ng2FilterPipeModule,

    
  ],
  declarations: [
    SmComponent,
    Guardiancomponent,
    AppContainerComponent,
    NavigationBarComponent,
    SidebarLeftComponent,
    SidebarRightComponent,
    PageContainerComponent,
    FooterComponent,
    StudentBirthday,
    EmployeeBirthday,
    ParentnavbarComponent,
    ParentsidebarComponent,
    parentcontainerComponent,
    ParentformconatinerComponent,


  ],
  providers: [

    SMStudentinfoService,
    EmployeeinfohdrService,
    StudentguardianService,
    TemplateService,
    SMMessageService,
    StudentbirthdayService,
    favoriteService,


  ]
})
export class SmModule { }



// WEBPACK FOOTER //
// ./src/app/shell/sm/sm.module.ts